import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import "./UploadSingleFile.css"
import {useLocation} from "react-router-dom";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {Button, TextField, Tooltip} from "@mui/material";
import {IoIosCloseCircle, IoMdEye, IoMdTrash} from "react-icons/io";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";

const AdministrationFilePopup = ({onClose, onFileUpload, users}) => {
    const [adminFile, setAdminFile] = useState(null);
    const [adminFileTitle, setAdminFileTitle] = useState("ადმინისტრაციული სამართალდარღვევის შესახებ ოქმი");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const adminFileInputRef = useRef(null);
    const [inpectOrderAttachmentDate, setInpectOrderAttachmentDate] = useState(null);
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [caseFileNumber, setCaseFileNumber] = useState('');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const disableUpload = adminFile === null || inpectOrderAttachmentDate === null || caseFileNumber === ''
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };


    const handleAdminFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setAlert({show: true, message: 'შეცდომა: ატვირთეთ მხოლოდ PDF ფაილები.', type: 'error'});
                setAdminFile(null);
            } else {
                setAdminFile(selectedFile);
                setAlert({...alert, show: false});
            }
        }
    }


    const handelDeleteFile = () => {
        setAdminFile(null)
        adminFileInputRef.current.value = ''
        setInpectOrderAttachmentDate(null)
    };


    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [onClose]);


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {
        try {
            const adminFileBase64 = await toBase64(adminFile);
            const adminFileData = {
                caseID: caseId,
                name: "ადმინისტრაციული სამართალდარღვევის შესახებ ოქმი",
                ext: adminFile.name.split('.').pop(),
                file: adminFileBase64,
                mainInfo: '',
                additionalInfo: '',
                shared: true,
                sharedTemp: true,
                blank: false,
                documentType: 0,
                internal: CaseFilesInternal.Yes,
                status: CaseFilesStatus.SentForVisage,
                decline: CaseFileDeclined.No,
                isUploaded: true,
                approvalDocument: false,
                caseFileNumber: caseFileNumber,
                declinedInternalStatus: 0,
                inpectOrderAttachment: true,
                inpectOrderAttachmentDate: inpectOrderAttachmentDate
                    ? new Date(inpectOrderAttachmentDate.setDate(inpectOrderAttachmentDate.getDate() + 1)).toISOString()
                    : null

            };

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, adminFileData);
            await sendNotification(response.data.resultId)


        } catch (error) {
            setAlert({show: true, message: "დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!", type: 'error'});
        } finally {
            setIsUploading(false);
            setIsModalOpen(false);
            onFileUpload();
            onClose();
        }
    };


    return (
        <div>
            <div className="upload-single-popup">
                <div className="upload-single-container-inspection">
                    <IoIosCloseCircle className="upload-single-close-icon-inspection"
                                      onClick={onClose}>Close</IoIosCloseCircle>
                    <div className="upload-single-header">
                        <p className="upload-single-title">ადმინისტრაციული სამართალდარღვევის შესახებ ოქმის ატვირთვა</p>
                    </div>
                    <div className={"admin-file-contaioner"}>

                        <Button variant="contained" onClick={() => adminFileInputRef.current.click()}
                                className="upload-single-button">
                            <div>
                                ადმინისტრაციული სამართალდარღვევის შესახებ ოქმი
                            </div>
                        </Button>
                        <input
                            type="file"
                            accept=".pdf"
                            ref={adminFileInputRef}
                            style={{display: 'none'}}
                            onChange={handleAdminFileChange}
                        />
                        {adminFile && (
                            <>
                                <div className="upload-single-selected-file">
                                    <span>{adminFile.name}</span>
                                    <div className="file-actions">
                                        <div style={{marginTop: 5}}>
                                            <IoMdEye
                                                className="file-icon preview-icon"
                                                onClick={() => window.open(URL.createObjectURL(adminFile), '_blank')}
                                            />

                                            <IoMdTrash
                                                className="file-icon delete-icon"
                                                onClick={handelDeleteFile}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <TextField
                                    label="ფაილის სახელი"
                                    variant="outlined"
                                    type="text"
                                    value={adminFileTitle}
                                    onChange={(e) => setAdminFileTitle(e.target.value)}
                                />
                                <TextField
                                    type="text"
                                    fullWidth
                                    label="დოკუმენტის ნომერი"
                                    variant="outlined"
                                    value={caseFileNumber}
                                    onChange={(e) => setCaseFileNumber(e.target.value)}
                                    InputProps={{inputProps: {min: 1}}}
                                />
                                <div className="full-width">
                                    <p>შედგენის თარიღი:</p>
                                    <DatePicker
                                        selected={inpectOrderAttachmentDate}
                                        onChange={(date) => setInpectOrderAttachmentDate(date)}
                                        locale={ka}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="აირჩიეთ თარიღი"
                                        className="full-width"
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="upload-single-footer">
                        <Tooltip title={adminFile === null ? "ატვირთეთ ადმინისტრაციული სამართალდარღვევის შესახებ ოქმი!" : ""}>
                            <div style={{width: "100%", cursor: adminFile === null ? "not-allowed" : "pointer"}}>
                                <Button style={{width: "100%"}} onClick={() => setIsModalOpen(true)}
                                        disabled={disableUpload} variant="contained">
                                    {isUploading ? 'ატვირთვა...' : 'დოკუმენტის ატვირთვა'}
                                </Button>
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                />

            </div>
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>

    );
};

export default AdministrationFilePopup;
